import React from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ADMIN } from "@/constants/testIds";

const FIELDS = [
  { key: "hero_title", label: "Hero title", type: "text" },
  { key: "hero_subtitle", label: "Hero subtitle", type: "textarea" },
  { key: "hero_cta", label: "Hero CTA label", type: "text" },
  { key: "about_headline", label: "About headline", type: "text" },
  { key: "about_body", label: "About body", type: "textarea" },
  { key: "mission", label: "Mission", type: "textarea" },
  { key: "vision", label: "Vision", type: "textarea" },
  { key: "founded_year", label: "Founded year", type: "text" },
  { key: "company_email", label: "Company email", type: "text" },
  { key: "company_phone", label: "Company phone", type: "text" },
  { key: "company_address", label: "Company address", type: "text" },
  { key: "linkedin_url", label: "LinkedIn URL", type: "text" },
  { key: "twitter_url", label: "Twitter / X URL", type: "text" },
];

export default function AdminSite() {
  const [data, setData] = React.useState(null);
  const [saving, setSaving] = React.useState(false);

  React.useEffect(() => { api.get("/site").then((r) => setData(r.data)); }, []);

  if (!data) return <div className="text-[color:var(--sky-admin-muted)]">Loading…</div>;

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/site", data);
      toast.success("Site content updated");
    } catch (err) {
      toast.error("Failed to save");
    } finally { setSaving(false); }
  };

  return (
    <div>
      <div className="overline text-[color:var(--sky-cyan)]">Content</div>
      <h1 className="mt-3 font-display font-black text-white text-3xl">Site content</h1>
      <p className="mt-2 text-[color:var(--sky-admin-muted)]">Edit the copy that appears across your public site.</p>

      <div className="mt-8 grid gap-5 admin-card p-6">
        {FIELDS.map((f) => (
          <div key={f.key} className="grid gap-1">
            <label className="text-xs uppercase tracking-widest text-[color:var(--sky-admin-muted)] font-bold">{f.label}</label>
            {f.type === "textarea" ? (
              <textarea rows={4} className="admin-input" value={data[f.key] || ""} onChange={(e) => setData({ ...data, [f.key]: e.target.value })} />
            ) : (
              <input className="admin-input" value={data[f.key] || ""} onChange={(e) => setData({ ...data, [f.key]: e.target.value })} />
            )}
          </div>
        ))}
        <button data-testid={ADMIN.saveBtn("site")} disabled={saving} className="admin-btn justify-self-start mt-2 disabled:opacity-60">
          {saving ? "Saving…" : "Save changes"}
        </button>
      </div>
    </div>
  );
}
